export const regexPatterns = {
    colorPicker: /^#[0-9a-fA-F]{6}$/,
    maskInput:
        /(2|3)[0-9][1-9][0-1][1-9][0-3][1-9](01|02|03|04|11|12|13|14|15|16|17|18|19|21|22|23|24|25|26|27|28|29|31|32|33|34|35|88)\d\d\d\d\d/,
    text: /^[0-9a-zA-Zء-ي ]{1,255}(?: [0-9a-zA-Zء-ي]+)*$/,
};
